<template>
  <card>
    <h5
      slot="header"
      class="card-title text-danger font-weight-bold"
    >
      Announcements
    </h5>
    <collapse>
      <collapse-item
        :name="a.Id"
        v-for="a in announcements"
        :key="a.Id"
      >
        <template v-slot:title>
          <div class="row">
            <div class="d-none d-md-flex col-1 align-items-start">
              <i
                class="bi bi-signpost-2"
                style="font-size: 2.2em;transform: none !important;"
              />
            </div>
            <div class="col-1 d-flex align-items-start">
              <el-dropdown
                v-if="a.Links.length > 0"
                trigger="click"
                @command="showLink"
              >
                <span class="el-dropdown-link">
                  <i
                    class="bi bi-paperclip text-primary"
                    style="font-size: 2.2em;transform: none !important;"
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :command="l.LinkUrl"
                    v-for="l in a.Links"
                    :key="l.Id"
                  >
                    {{ l.Headline }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="col-9 pt-2">
              <b>{{ a.Headline }}</b><br><span class="ml-3">{{ formatDateOf(a.DateOf) }}</span>
            </div>
          </div>
        </template>
        <div v-html="a.Contents" />
      </collapse-item>
    </collapse>
  </card>
</template>

<script>
import announcementApi from '@/services/api/announcement.js'
import Collapse from '@/plugins/paper-components/collapse/collapse.vue'
import CollapseItem from '@/plugins/paper-components/collapse/collapse-item.vue'
import formatter from '@/services/formatter.js'

export default {
  name: 'AnnouncementView',
  components: {
    Collapse,
    CollapseItem
  },
  props: {
    includeParticipant: {
      type: Boolean,
      default: false
    },
    includeStaff: {
      type: Boolean,
      default: false
    },
    includeDrafts: {
      type: Boolean,
      default: false
    },
    includeWelcomeLetter: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      announcements: []
    }
  },
  mounted: function () {
    this.getData()
  },
  methods: {
    getData: function () {
      announcementApi.get(this.$root.courseKey, this.includeParticipant, this.includeStaff, this.includeDrafts, this.includeWelcomeLetter)
        .then(x => {
          this.announcements = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    formatDateOf: function (value) {
      return formatter.formatAsDateTime(value)
    },
    showLink: function (linkUrl) {
      window.open(linkUrl, '_blank')
    }
  }
}
</script>
<style scoped>
  .card .card-body {
    padding-top: 0 !important;
  }
</style>
